import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from './shared/models';
import { applicationMenus } from './core/components/header/constants/menu.constants';
import { Subject, takeUntil } from 'rxjs';
import { LocalStorageService } from './shared/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'idsf-frontend';
  menuList: Menu[];
  activatedRouteRef: ActivatedRoute;

  routerRef: Router;
  private readonly user = this.storageService.get('user');
  private readonly destroySubject: Subject<boolean> = new Subject();

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private storageService: LocalStorageService
  ) {
    this.activatedRouteRef = activatedRoute;
    this.routerRef = router;
  }
  ngOnInit(): void {
    this.menuList = applicationMenus;
    this.authObserver();
  }

  ngOnDestroy(): void {
    this.destroySubject.next(true);
    this.destroySubject.complete();
  }

  authObserver(): void {
    this.storageService
      .watch('user')
      .pipe(takeUntil(this.destroySubject))
      .subscribe((auth) => {
        if (!auth || (auth && auth?.id !== this.user?.id)) {
          location.reload();
        }
      });
  }
}
